export const shortAddress = (addr) => {
  if (!addr) return '-';
  return `${addr.slice(0, 6)}...${addr.slice(-4)}`;
};

export const formatDate = (dateString) =>
  new Date(dateString)
    .toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    })
    .replace(',', '');

export const formatDateMD = (dateString) =>
  new Date(dateString)
    .toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
    })
    .replace(',', '');
